/**
 * Created by hls on 2017/11/22
 * bd基础模块路由.
 */

import _import from './_import_development'

export  default {
  path: '/ht',
  name: 'ht',
  component: _import("Home"),
  meta: {permission: false},
  children: [
    { path: 'ContractList',component:_import("ht/ContractList"),name:'合同列表',meta:{ keepAlive:true }},
    { path: 'ContractInfo',component:_import("ht/ContractInfo"),name:'合同详情'},
    { path: 'ContractAdd',component:_import("ht/ContractAdd"),name:'合同编辑'},
    { path: 'ContractChangeList',component:_import("ht/ContractChangeList"),name:'合同变更列表'},
    { path: 'ContractChangeInfo',component:_import("ht/ContractChangeInfo"),name:'合同变更列表'},
    { path: 'ContractChangeAdd',component:_import("ht/ContractChangeAdd"),name:'合同变更编辑'},
    { path: 'ContractCustomerList',component:_import("ht/ContractCustomerList"),name:'合同列表'},
    { path: 'ContractCustomerInfo',component:_import("ht/ContractCustomerInfo"),name:'合同详情'},
    { path: 'ContractCustomerChangeInfo',component:_import("ht/ContractCustomerChangeInfo"),name:'合同变更详情'},
    { path: 'ContractPriceTable',component:_import("ht/ContractPriceTable"),name:'合同价表'},
    { path: 'DynamicLines',component:_import("ht/DynamicLines"),name:'客户动态信用额度表'},
    { path: 'ContractBatchUpdate',component:_import("ht/ContractBatchUpdate"),name:'批量修改'},
    { path: 'ContractBatchAdd',component:_import("ht/ContractBatchAdd"),name:'批量新增'},
    { path: 'ContractBatchAdjustment',component:_import("ht/ContractBatchAdjustment"),name:'批量调整'},
  ]
}



// WEBPACK FOOTER //
// ./src/router/ht.js